function OnboardImage2Dark() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 388 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11442)'>
        <path
          d='M195.029 180.052H192.593V181.713H191.651V182.543H189.935V183.429H188.44V185.09H189.16V186.751H190.046V190.96H192.426V190.074H195.084V190.96H197.52V186.751H198.462V185.09H199.237V183.429H197.52V182.543H195.859V181.713H195.029V180.052Z'
          fill='#FEF187'
        />
        <path
          d='M195.029 181.547H192.593V181.658H191.596V182.488H189.935V183.429H188.385V185.091H189.215V186.752H190.046V186.862H190.821V189.299H196.026L195.97 182.544L195.029 182.488V181.547Z'
          fill='#FFFE00'
        />
        <path d='M195.084 182.543H194.254V185.09H191.707L191.762 186.696H195.084V182.543Z' fill='#FABF50' />
        <rect x='192.371' y='179' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='192.371' y='190.074' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='189.935' y='190.96' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='195.029' y='190.96' width='2.65773' height='0.99665' fill='#E98116' />
        <rect
          x='195.029'
          y='181.657'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 195.029 181.657)'
          fill='#E98116'
        />
        <rect
          x='191.596'
          y='181.657'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 191.596 181.657)'
          fill='#E98116'
        />
        <rect
          x='187.388'
          y='185.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 187.388 185.09)'
          fill='#E98116'
        />
        <rect
          x='188.163'
          y='186.752'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 188.163 186.752)'
          fill='#E98116'
        />
        <rect
          x='189.049'
          y='190.96'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 189.049 190.96)'
          fill='#E98116'
        />
        <rect
          x='197.576'
          y='190.96'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 197.576 190.96)'
          fill='#E98116'
        />
        <rect
          x='199.237'
          y='185.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 199.237 185.09)'
          fill='#E98116'
        />
        <rect
          x='198.462'
          y='186.752'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 198.462 186.752)'
          fill='#E98116'
        />
        <rect x='189.935' y='181.547' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='195.915' y='181.547' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='197.576' y='182.433' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='188.274' y='182.433' width='1.66108' height='0.99665' fill='#E98116' />
        <path d='M194.973 188.468V186.752V186.641H191.707V188.468H194.973Z' fill='#FEDF13' />
        <path d='M194.254 185.091V182.599H191.707V185.091H194.254Z' fill='#FFFFFD' />
        <path
          d='M217.39 190.525L215.056 189.826L214.58 191.418L213.678 191.148L213.44 191.943L211.795 191.451L211.541 192.3L210.109 191.871L209.633 193.463L210.323 193.669L209.846 195.26L210.695 195.514L209.488 199.546L211.769 200.228L212.023 199.38L214.569 200.142L214.315 200.99L216.649 201.689L217.856 197.658L218.758 197.928L219.234 196.336L219.977 196.559L220.453 194.967L218.809 194.475L219.063 193.626L217.471 193.15L217.709 192.354L216.914 192.116L217.39 190.525Z'
          fill='#FEF187'
        />
        <path
          d='M216.961 191.957L214.627 191.258L214.596 191.364L213.641 191.079L213.403 191.874L211.811 191.398L211.541 192.3L210.056 191.855L209.58 193.447L210.376 193.685L209.899 195.276L210.695 195.514L210.663 195.62L211.406 195.843L210.707 198.177L215.693 199.669L217.577 193.182L216.691 192.859L216.961 191.957Z'
          fill='#FFFE00'
        />
        <path
          d='M216.729 192.928L215.933 192.69L215.203 195.13L212.763 194.399L212.355 195.953L215.538 196.906L216.729 192.928Z'
          fill='#FABF50'
        />
        <rect
          x='215.146'
          y='188.755'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 215.146 188.755)'
          fill='#E98116'
        />
        <rect
          x='211.97'
          y='199.364'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 211.97 199.364)'
          fill='#E98116'
        />
        <rect
          x='209.382'
          y='199.514'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 209.382 199.514)'
          fill='#E98116'
        />
        <rect
          x='214.262'
          y='200.975'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 214.262 200.975)'
          fill='#E98116'
        />
        <rect
          x='216.93'
          y='192.063'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 216.93 192.063)'
          fill='#E98116'
        />
        <rect
          x='213.641'
          y='191.079'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 213.641 191.079)'
          fill='#E98116'
        />
        <rect
          x='208.625'
          y='193.161'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 208.625 193.161)'
          fill='#E98116'
        />
        <rect
          x='208.891'
          y='194.974'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 208.891 194.974)'
          fill='#E98116'
        />
        <rect
          x='208.534'
          y='199.26'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 208.534 199.26)'
          fill='#E98116'
        />
        <rect
          x='216.702'
          y='201.705'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 216.702 201.705)'
          fill='#E98116'
        />
        <rect
          x='219.977'
          y='196.559'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 219.977 196.559)'
          fill='#E98116'
        />
        <rect
          x='218.758'
          y='197.927'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 218.758 197.927)'
          fill='#E98116'
        />
        <rect
          x='212.081'
          y='190.496'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 212.081 190.496)'
          fill='#E98116'
        />
        <rect
          x='217.81'
          y='192.211'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 217.81 192.211)'
          fill='#E98116'
        />
        <rect
          x='219.147'
          y='193.536'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 219.147 193.536)'
          fill='#E98116'
        />
        <rect
          x='210.236'
          y='190.869'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 210.236 190.869)'
          fill='#E98116'
        />
        <path
          d='M214.924 198.572L215.416 196.927L215.448 196.821L212.318 195.885L211.794 197.635L214.924 198.572Z'
          fill='#FEDF13'
        />
        <path d='M215.203 195.13L215.917 192.743L213.477 192.012L212.763 194.399L215.203 195.13Z' fill='#FFFFFD' />
        <path
          d='M172.649 189.826L170.315 190.525L170.791 192.116L169.889 192.386L170.127 193.182L168.483 193.674L168.737 194.522L167.305 194.951L167.781 196.542L168.471 196.336L168.947 197.927L169.795 197.673L171.002 201.705L173.283 201.022L173.029 200.174L175.575 199.412L175.829 200.26L178.163 199.562L176.957 195.53L177.858 195.261L177.382 193.669L178.125 193.447L177.649 191.856L176.004 192.348L175.75 191.499L174.159 191.975L173.921 191.18L173.125 191.418L172.649 189.826Z'
          fill='#FEF187'
        />
        <path
          d='M173.077 191.259L170.743 191.957L170.775 192.063L169.82 192.349L170.059 193.145L168.467 193.621L168.737 194.523L167.252 194.967L167.728 196.558L168.524 196.32L169 197.912L169.796 197.674L169.827 197.78L170.57 197.557L171.268 199.891L176.255 198.399L174.265 191.944L173.347 192.16L173.077 191.259Z'
          fill='#FFFE00'
        />
        <path
          d='M173.416 192.197L172.62 192.436L173.351 194.876L170.911 195.606L171.424 197.128L174.607 196.176L173.416 192.197Z'
          fill='#FABF50'
        />
        <rect
          x='169.801'
          y='189.58'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 169.801 189.58)'
          fill='#E98116'
        />
        <rect
          x='172.976'
          y='200.189'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 172.976 200.189)'
          fill='#E98116'
        />
        <rect
          x='170.896'
          y='201.737'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 170.896 201.737)'
          fill='#E98116'
        />
        <rect
          x='175.776'
          y='200.276'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 175.776 200.276)'
          fill='#E98116'
        />
        <rect
          x='173.109'
          y='191.365'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 173.109 191.365)'
          fill='#E98116'
        />
        <rect
          x='169.82'
          y='192.349'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 169.82 192.349)'
          fill='#E98116'
        />
        <rect
          x='166.773'
          y='196.844'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 166.773 196.844)'
          fill='#E98116'
        />
        <rect
          x='167.992'
          y='198.213'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 167.992 198.213)'
          fill='#E98116'
        />
        <rect
          x='170.047'
          y='201.991'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 170.047 201.991)'
          fill='#E98116'
        />
        <rect
          x='178.216'
          y='199.546'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 178.216 199.546)'
          fill='#E98116'
        />
        <rect
          x='178.125'
          y='193.447'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 178.125 193.447)'
          fill='#E98116'
        />
        <rect
          x='177.858'
          y='195.261'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 177.858 195.261)'
          fill='#E98116'
        />
        <rect
          x='168.197'
          y='192.719'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 168.197 192.719)'
          fill='#E98116'
        />
        <rect
          x='173.926'
          y='191.005'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 173.926 191.005)'
          fill='#E98116'
        />
        <rect
          x='175.771'
          y='191.377'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 175.771 191.377)'
          fill='#E98116'
        />
        <rect
          x='166.86'
          y='194.044'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 166.86 194.044)'
          fill='#E98116'
        />
        <path
          d='M175.009 197.905L174.517 196.261L174.485 196.155L171.355 197.091L171.879 198.842L175.009 197.905Z'
          fill='#FEDF13'
        />
        <path d='M173.351 194.876L172.636 192.489L170.196 193.219L170.911 195.606L173.351 194.876Z' fill='#FFFFFD' />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 6.31873 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect x='40.6699' y='219.422' width='70.5358' height='6.35458' fill='#FBFBFB' fillOpacity='0.5' />
        <rect x='40.6699' y='308.386' width='70.5358' height='6.35458' fill='#FBFBFB' fillOpacity='0.5' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 40.6699 225.776)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 117.561 225.776)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 117.561 302.667)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 41.3057 302.667)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 123.915 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 34.951 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <path
          d='M78.6092 248.547L82.7279 248.547L82.7279 252.666L86.8467 252.666L86.8467 256.784L70.3718 256.784L70.3718 265.022L86.8467 265.022L86.8467 269.14L70.3718 269.14L70.3718 277.378L86.8467 277.378L86.8467 281.497L82.7279 281.497L82.7279 285.615L78.6092 285.615L78.6092 281.497L74.4905 281.497L74.4905 285.615L70.3718 285.615L70.3718 281.497L62.1344 281.497L62.1344 277.378L66.2531 277.378L66.2531 269.14L62.1344 269.14L62.1344 265.022L66.2531 265.022L66.2531 256.784L62.1344 256.784L62.1344 252.666L70.3718 252.666L70.3718 248.547L74.4905 248.547L74.4905 252.666L78.6092 252.666L78.6092 248.547ZM86.8467 277.378L86.8467 269.14L90.9654 269.14L90.9654 277.378L86.8467 277.378ZM86.8467 265.022L86.8467 256.784L90.9654 256.784L90.9654 265.022L86.8467 265.022Z'
          fill='white'
          fillOpacity='0.5'
        />
        <path
          d='M228.714 226.041H158.548V232.219H152.812L152.37 302.384H158.99V308.562L228.714 308.121V302.825H235.333L234.892 232.219H228.714V226.041Z'
          fill='#391998'
        />
        <path
          d='M228.455 225.687V231.953H158.142L159.099 302.266H152.572V231.953H158.142V225.687H228.455Z'
          fill='#5E33DC'
        />
        <path
          d='M229.151 232.649H234.721V302.266H228.455V308.532H158.838V302.962L228.455 302.266L229.151 232.649Z'
          fill='#291170'
        />
        <rect x='158.266' y='219.422' width='70.5358' height='6.35458' fill='#D5C6FF' />
        <rect x='158.266' y='308.386' width='70.5358' height='6.35458' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 158.266 225.776)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 170.34 237.215)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 223.718 237.215)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 223.718 290.593)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 170.34 290.593)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 235.156 225.776)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 235.156 302.667)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 158.902 302.667)' fill='#D5C6FF' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 241.511 231.495)' fill='#D5C6FF' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 152.547 231.495)' fill='#D5C6FF' />
        <rect x='275.863' y='219.422' width='70.5358' height='6.35458' fill='#FBFBFB' fillOpacity='0.5' />
        <rect x='275.863' y='308.386' width='70.5358' height='6.35458' fill='#FBFBFB' fillOpacity='0.5' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 275.863 225.776)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 352.753 225.776)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 352.753 302.667)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 276.499 302.667)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 359.108 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 270.143 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <path
          d='M313.632 248.202L317.751 248.202L317.751 252.321L321.87 252.321L321.87 256.439L305.395 256.439L305.395 264.677L321.87 264.677L321.87 268.795L305.395 268.795L305.395 277.033L321.87 277.033L321.87 281.152L317.751 281.152L317.751 285.27L313.632 285.27L313.632 281.152L309.513 281.152L309.513 285.27L305.395 285.27L305.395 281.152L297.157 281.152L297.157 277.033L301.276 277.033L301.276 268.795L297.157 268.795L297.157 264.677L301.276 264.677L301.276 256.439L297.157 256.439L297.157 252.321L305.395 252.321L305.395 248.202L309.513 248.202L309.513 252.321L313.632 252.321L313.632 248.202ZM321.87 277.033L321.87 268.795L325.988 268.795L325.988 277.033L321.87 277.033ZM321.87 264.677L321.87 256.439L325.988 256.439L325.988 264.677L321.87 264.677Z'
          fill='white'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 393.46 225.776)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 394.095 302.667)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 387.74 231.495)'
          fill='#FBFBFB'
          fillOpacity='0.5'
        />
        <path
          d='M180.956 277.053V260.146H174.999V257.154H190.444V260.146H184.5V277.053H180.956ZM191.74 277.053L199.049 265.759L198.235 268.6V266.986L191.795 257.154H195.987L200.621 264.642H202.248L199.945 265.98L205.379 257.154H209.364L202.717 267.083V268.696L201.876 265.855L209.254 277.053H205.158L200.455 269.731H198.814L201.173 268.42L195.615 277.053H191.74Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3383_11442'>
          <rect width='388' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
function OnboardImage2Light() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 389 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11432)'>
        <rect opacity='0.26' width='10' height='10' transform='matrix(1 0 0 -1 308.705 107)' fill='#010101' />
        <rect opacity='0.22' width='10' height='10' transform='matrix(1 0 0 -1 241.705 76)' fill='#010101' />
        <rect opacity='0.36' width='10' height='10' transform='matrix(1 0 0 -1 178.705 107)' fill='#010101' />
        <rect opacity='0.17' width='10' height='10' transform='matrix(1 0 0 -1 241.705 179)' fill='#010101' />
        <rect opacity='0.3' width='10' height='10' transform='matrix(1 0 0 -1 61.7048 124)' fill='#010101' />
        <rect opacity='0.39' width='10' height='10' transform='matrix(1 0 0 -1 147.705 53)' fill='#010101' />
        <rect opacity='0.23' width='10' height='10' transform='matrix(1 0 0 -1 34.7048 28)' fill='#010101' />
        <rect opacity='0.27' width='10' height='10' transform='matrix(1 0 0 -1 318.705 222)' fill='#010101' />
        <rect opacity='0.37' width='10' height='10' transform='matrix(1 0 0 -1 97.7048 455)' fill='#010101' />
        <rect opacity='0.38' width='10' height='10' transform='matrix(1 0 0 -1 39.7048 399)' fill='#010101' />
        <rect opacity='0.23' width='10' height='10' transform='matrix(1 0 0 -1 273.705 414)' fill='#010101' />
        <rect opacity='0.12' width='10' height='10' transform='matrix(1 0 0 -1 283.705 475)' fill='#010101' />
        <rect opacity='0.28' width='10' height='10' transform='matrix(1 0 0 -1 149.705 409)' fill='#010101' />
        <rect opacity='0.17' width='10' height='10' transform='matrix(1 0 0 -1 49.7048 201)' fill='#010101' />
        <path
          d='M196.029 202.052H193.593V203.713H192.651V204.543H190.935V205.429H189.44V207.09H190.16V208.751H191.046V212.96H193.426V212.074H196.084V212.96H198.52V208.751H199.462V207.09H200.237V205.429H198.52V204.543H196.859V203.713H196.029V202.052Z'
          fill='#FEF187'
        />
        <path
          d='M196.029 203.547H193.593V203.658H192.596V204.488H190.935V205.429H189.385V207.091H190.215V208.752H191.046V208.862H191.821V211.299H197.026L196.97 204.544L196.029 204.488V203.547Z'
          fill='#FFFE00'
        />
        <path d='M196.084 204.543H195.254V207.09H192.707L192.762 208.696H196.084V204.543Z' fill='#FABF50' />
        <rect x='193.371' y='201' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='193.371' y='212.074' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='190.935' y='212.959' width='2.65773' height='0.99665' fill='#E98116' />
        <rect x='196.029' y='212.959' width='2.65773' height='0.99665' fill='#E98116' />
        <rect
          x='196.029'
          y='203.658'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 196.029 203.658)'
          fill='#E98116'
        />
        <rect
          x='192.596'
          y='203.658'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 192.596 203.658)'
          fill='#E98116'
        />
        <rect
          x='188.388'
          y='207.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 188.388 207.09)'
          fill='#E98116'
        />
        <rect
          x='189.163'
          y='208.751'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 189.163 208.751)'
          fill='#E98116'
        />
        <rect
          x='190.049'
          y='212.959'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 190.049 212.959)'
          fill='#E98116'
        />
        <rect
          x='198.576'
          y='212.959'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 198.576 212.959)'
          fill='#E98116'
        />
        <rect
          x='200.237'
          y='207.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 200.237 207.09)'
          fill='#E98116'
        />
        <rect
          x='199.462'
          y='208.751'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 199.462 208.751)'
          fill='#E98116'
        />
        <rect x='190.935' y='203.547' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='196.915' y='203.547' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='198.576' y='204.433' width='1.66108' height='0.99665' fill='#E98116' />
        <rect x='189.274' y='204.433' width='1.66108' height='0.99665' fill='#E98116' />
        <path d='M195.973 210.468V208.751V208.641H192.707V210.468H195.973Z' fill='#FEDF13' />
        <path d='M195.254 207.09V204.599H192.707V207.09H195.254Z' fill='#FFFFFD' />
        <path
          d='M218.39 212.525L216.056 211.826L215.58 213.417L214.678 213.147L214.44 213.943L212.795 213.451L212.541 214.3L211.109 213.871L210.633 215.462L211.323 215.669L210.846 217.26L211.695 217.514L210.488 221.545L212.769 222.228L213.023 221.379L215.569 222.141L215.315 222.99L217.649 223.689L218.856 219.657L219.758 219.927L220.234 218.336L220.977 218.558L221.453 216.967L219.809 216.475L220.063 215.626L218.471 215.15L218.709 214.354L217.914 214.116L218.39 212.525Z'
          fill='#FEF187'
        />
        <path
          d='M217.961 213.957L215.627 213.258L215.596 213.364L214.641 213.079L214.403 213.874L212.811 213.398L212.541 214.3L211.056 213.855L210.58 215.447L211.376 215.685L210.899 217.276L211.695 217.514L211.663 217.62L212.406 217.843L211.707 220.177L216.693 221.669L218.577 215.182L217.691 214.859L217.961 213.957Z'
          fill='#FFFE00'
        />
        <path
          d='M217.729 214.927L216.933 214.689L216.203 217.129L213.763 216.399L213.355 217.953L216.538 218.906L217.729 214.927Z'
          fill='#FABF50'
        />
        <rect
          x='216.146'
          y='210.755'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 216.146 210.755)'
          fill='#E98116'
        />
        <rect
          x='212.97'
          y='221.363'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 212.97 221.363)'
          fill='#E98116'
        />
        <rect
          x='210.382'
          y='221.514'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 210.382 221.514)'
          fill='#E98116'
        />
        <rect
          x='215.262'
          y='222.974'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 215.262 222.974)'
          fill='#E98116'
        />
        <rect
          x='217.93'
          y='214.063'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 217.93 214.063)'
          fill='#E98116'
        />
        <rect
          x='214.641'
          y='213.079'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 214.641 213.079)'
          fill='#E98116'
        />
        <rect
          x='209.625'
          y='215.161'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 209.625 215.161)'
          fill='#E98116'
        />
        <rect
          x='209.891'
          y='216.974'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 209.891 216.974)'
          fill='#E98116'
        />
        <rect
          x='209.534'
          y='221.26'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 209.534 221.26)'
          fill='#E98116'
        />
        <rect
          x='217.702'
          y='223.705'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 217.702 223.705)'
          fill='#E98116'
        />
        <rect
          x='220.977'
          y='218.558'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 220.977 218.558)'
          fill='#E98116'
        />
        <rect
          x='219.758'
          y='219.927'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 219.758 219.927)'
          fill='#E98116'
        />
        <rect
          x='213.081'
          y='212.496'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 213.081 212.496)'
          fill='#E98116'
        />
        <rect
          x='218.81'
          y='214.211'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 218.81 214.211)'
          fill='#E98116'
        />
        <rect
          x='220.147'
          y='215.536'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 220.147 215.536)'
          fill='#E98116'
        />
        <rect
          x='211.236'
          y='212.869'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 211.236 212.869)'
          fill='#E98116'
        />
        <path
          d='M215.924 220.571L216.416 218.927L216.448 218.821L213.318 217.884L212.794 219.635L215.924 220.571Z'
          fill='#FEDF13'
        />
        <path d='M216.203 217.13L216.917 214.743L214.477 214.012L213.763 216.399L216.203 217.13Z' fill='#FFFFFD' />
        <path
          d='M173.649 211.826L171.315 212.525L171.791 214.116L170.889 214.386L171.127 215.182L169.483 215.674L169.737 216.522L168.305 216.951L168.781 218.542L169.471 218.336L169.947 219.927L170.795 219.673L172.002 223.705L174.283 223.022L174.029 222.174L176.575 221.412L176.829 222.26L179.163 221.562L177.957 217.53L178.858 217.261L178.382 215.669L179.125 215.447L178.649 213.856L177.004 214.348L176.75 213.499L175.159 213.975L174.921 213.18L174.125 213.418L173.649 211.826Z'
          fill='#FEF187'
        />
        <path
          d='M174.077 213.258L171.743 213.957L171.775 214.063L170.82 214.348L171.059 215.144L169.467 215.62L169.737 216.522L168.252 216.967L168.728 218.558L169.524 218.32L170 219.911L170.796 219.673L170.827 219.779L171.57 219.557L172.268 221.891L177.255 220.399L175.265 213.943L174.347 214.16L174.077 213.258Z'
          fill='#FFFE00'
        />
        <path
          d='M174.416 214.197L173.62 214.435L174.351 216.875L171.911 217.606L172.424 219.128L175.607 218.176L174.416 214.197Z'
          fill='#FABF50'
        />
        <rect
          x='170.801'
          y='211.58'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 170.801 211.58)'
          fill='#E98116'
        />
        <rect
          x='173.976'
          y='222.189'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 173.976 222.189)'
          fill='#E98116'
        />
        <rect
          x='171.896'
          y='223.736'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 171.896 223.736)'
          fill='#E98116'
        />
        <rect
          x='176.776'
          y='222.276'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 176.776 222.276)'
          fill='#E98116'
        />
        <rect
          x='174.109'
          y='213.364'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 174.109 213.364)'
          fill='#E98116'
        />
        <rect
          x='170.82'
          y='214.349'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 170.82 214.349)'
          fill='#E98116'
        />
        <rect
          x='167.773'
          y='218.844'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 167.773 218.844)'
          fill='#E98116'
        />
        <rect
          x='168.992'
          y='220.213'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 168.992 220.213)'
          fill='#E98116'
        />
        <rect
          x='171.047'
          y='223.99'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 171.047 223.99)'
          fill='#E98116'
        />
        <rect
          x='179.216'
          y='221.546'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 179.216 221.546)'
          fill='#E98116'
        />
        <rect
          x='179.125'
          y='215.447'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 179.125 215.447)'
          fill='#E98116'
        />
        <rect
          x='178.858'
          y='217.26'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 178.858 217.26)'
          fill='#E98116'
        />
        <rect
          x='169.197'
          y='214.719'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 169.197 214.719)'
          fill='#E98116'
        />
        <rect
          x='174.926'
          y='213.004'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 174.926 213.004)'
          fill='#E98116'
        />
        <rect
          x='176.771'
          y='213.377'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 176.771 213.377)'
          fill='#E98116'
        />
        <rect
          x='167.86'
          y='216.044'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 167.86 216.044)'
          fill='#E98116'
        />
        <path
          d='M176.009 219.905L175.517 218.26L175.485 218.154L172.355 219.091L172.879 220.841L176.009 219.905Z'
          fill='#FEDF13'
        />
        <path d='M174.351 216.876L173.636 214.489L171.196 215.219L171.911 217.606L174.351 216.876Z' fill='#FFFFFD' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 0.9646 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 0.9646 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 7.31934 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect x='41.671' y='241.422' width='70.5358' height='6.35458' fill='#111112' fillOpacity='0.3' />
        <rect x='41.671' y='330.386' width='70.5358' height='6.35458' fill='#111112' fillOpacity='0.3' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 41.671 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 118.562 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 118.562 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 42.3066 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 124.916 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 35.9514 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <path
          d='M79.4403 270.202L83.559 270.202L83.559 274.321L87.6777 274.321L87.6777 278.44L71.2029 278.44L71.2029 286.677L87.6777 286.677L87.6777 290.796L71.2029 290.796L71.2029 299.033L87.6777 299.033L87.6777 303.152L83.559 303.152L83.559 307.271L79.4403 307.271L79.4403 303.152L75.3216 303.152L75.3216 307.271L71.2029 307.271L71.2029 303.152L62.9655 303.152L62.9655 299.033L67.0842 299.033L67.0842 290.796L62.9655 290.796L62.9655 286.677L67.0842 286.677L67.0842 278.44L62.9655 278.44L62.9655 274.321L71.2029 274.321L71.2029 270.202L75.3216 270.202L75.3216 274.321L79.4403 274.321L79.4403 270.202ZM87.6777 299.033L87.6777 290.796L91.7964 290.796L91.7964 299.033L87.6777 299.033ZM87.6777 286.677L87.6777 278.44L91.7964 278.44L91.7964 286.677L87.6777 286.677Z'
          fill='#111112'
          fillOpacity='0.3'
        />
        <path
          d='M229.715 248.041H159.55V254.219H153.813L153.371 324.384H159.991V330.562L229.715 330.121V324.826H236.334L235.893 254.219H229.715V248.041Z'
          fill='#391998'
        />
        <path
          d='M229.456 247.688V253.953H159.143L160.1 324.267H153.573V253.953H159.143V247.688H229.456Z'
          fill='#5E33DC'
        />
        <path
          d='M230.152 254.649H235.722V324.267H229.456V330.532H159.839V324.963L229.456 324.267L230.152 254.649Z'
          fill='#291170'
        />
        <rect x='159.267' y='241.422' width='70.5358' height='6.35458' fill='#D5C6FF' />
        <rect x='159.267' y='330.386' width='70.5358' height='6.35458' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 159.267 247.777)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 171.341 259.215)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 224.719 259.215)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 224.719 312.593)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 171.341 312.593)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 236.158 247.777)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 236.158 324.667)' fill='#D5C6FF' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 159.903 324.667)' fill='#D5C6FF' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 242.512 253.496)' fill='#D5C6FF' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 153.548 253.496)' fill='#D5C6FF' />
        <path
          d='M183.802 299V282.093H177.845V279.101H193.29V282.093H187.346V299H183.802ZM194.586 299L201.895 287.706L201.082 290.547V288.933L194.641 279.101H198.834L203.467 286.589H205.095L202.792 287.926L208.225 279.101H212.21L205.563 289.03V290.643L204.722 287.802L212.1 299H208.004L203.302 291.677H201.661L204.019 290.367L198.461 299H194.586Z'
          fill='white'
        />
        <rect x='276.864' y='241.422' width='70.5358' height='6.35458' fill='#111112' fillOpacity='0.3' />
        <rect x='276.864' y='330.386' width='70.5358' height='6.35458' fill='#111112' fillOpacity='0.3' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 276.864 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 353.755 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 353.755 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 277.5 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 360.109 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 271.145 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <path
          d='M314.633 270.202L318.752 270.202L318.752 274.321L322.871 274.321L322.871 278.44L306.396 278.44L306.396 286.677L322.871 286.677L322.871 290.796L306.396 290.796L306.396 299.033L322.871 299.033L322.871 303.152L318.752 303.152L318.752 307.271L314.633 307.271L314.633 303.152L310.515 303.152L310.515 307.271L306.396 307.271L306.396 303.152L298.159 303.152L298.159 299.033L302.277 299.033L302.277 290.796L298.159 290.796L298.159 286.677L302.277 286.677L302.277 278.44L298.159 278.44L298.159 274.321L306.396 274.321L306.396 270.202L310.515 270.202L310.515 274.321L314.633 274.321L314.633 270.202ZM322.871 299.033L322.871 290.796L326.99 290.796L326.99 299.033L322.871 299.033ZM322.871 286.677L322.871 278.44L326.99 278.44L326.99 286.677L322.871 286.677Z'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 394.461 247.777)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 395.097 324.667)'
          fill='#111112'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 388.741 253.496)'
          fill='#111112'
          fillOpacity='0.3'
        />
      </g>
      <defs>
        <clipPath id='clip0_3383_11432'>
          <rect width='389' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function OnboardImage2() {
  return (
    <>
      <div className='show-on-dark-theme'>
        <OnboardImage2Dark />
      </div>
      <div className='show-on-light-theme'>
        <OnboardImage2Light />
      </div>
    </>
  )
}
